import { Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./layout/admin-layout.component').then((m) => m.AdminLayoutComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./features/dashboard/admin-dashboard.component').then((m) => m.AdminDashboardComponent)
      },
      {
        path: 'products',
        loadComponent: () =>
          import('./features/products/admin-product-list.component').then((m) => m.AdminProductListComponent)
      },
      {
        path: 'products/:id',
        loadComponent: () =>
          import('./features/products/admin-product-form.component').then((m) => m.AdminProductFormComponent)
      },
      {
        path: 'categories',
        loadComponent: () =>
          import('./features/categories/admin-category-list.component').then((m) => m.AdminCategoryListComponent)
      },
      {
        path: 'categories/:id',
        loadComponent: () =>
          import('./features/categories/admin-category-form.component').then((m) => m.AdminCategoryFormComponent)
      },
      {
        path: 'orders',
        loadComponent: () =>
          import('./features/orders/admin-order-list.component').then((m) => m.AdminOrderListComponent)
      },
      {
        path: 'orders/:id',
        loadComponent: () =>
          import('./features/orders/admin-order-detail.component').then((m) => m.AdminOrderDetailComponent)
      },
      {
        path: 'customers',
        loadComponent: () =>
          import('./features/customers/admin-customer-list.component').then((m) => m.AdminCustomerListComponent)
      },
      {
        path: 'customers/:id',
        loadComponent: () =>
          import('./features/customers/admin-customer-detail.component').then((m) => m.AdminCustomerDetailComponent)
      },
      {
        path: 'discounts',
        loadComponent: () =>
          import('./features/discounts/admin-coupon-list.component').then((m) => m.AdminCouponListComponent)
      },
      {
        path: 'discounts/:id',
        loadComponent: () =>
          import('./features/discounts/admin-coupon-form.component').then((m) => m.AdminCouponFormComponent)
      },
      {
        path: 'banners',
        loadComponent: () =>
          import('./features/banners/admin-banner-list.component').then((m) => m.AdminBannerListComponent)
      },
      {
        path: 'banners/:id',
        loadComponent: () =>
          import('./features/banners/admin-banner-form.component').then((m) => m.AdminBannerFormComponent)
      },
      {
        path: 'reports',
        loadComponent: () =>
          import('./features/reports/admin-reports.component').then((m) => m.AdminReportsComponent)
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./features/settings/admin-settings.component').then((m) => m.AdminSettingsComponent)
      }
    ]
  }
];
